export default __webpack_public_path__ + "static/logo-1ba2e2883d79da902ca0dc044c73d759.png";